window.ParticipantNames = window.ParticipantNames || {};

// Registry delle istanze attive — una per sectionId
window.ParticipantNames._instances = window.ParticipantNames._instances || {};

window.ParticipantNames.init = function(sectionId, config) {
  // Distrugge istanza precedente se esiste
  if (window.ParticipantNames._instances[sectionId]) {
    window.ParticipantNames._instances[sectionId].destroy();
  }
  const instance = createInstance(sectionId, config);
  window.ParticipantNames._instances[sectionId] = instance;
  instance.start();
};

function createInstance(sectionId, config) {
  const formId          = 'product-form-' + sectionId;
  const fieldsContainer = document.getElementById('participant-fields-' + sectionId);
  const quantityInput   = document.getElementById('Quantity-' + sectionId);
  const productInfo     = document.getElementById('ProductInfo-' + sectionId);

  const noop = { start: function(){}, destroy: function(){}, resetToOne: function(){} };
  if (!fieldsContainer || !quantityInput) return noop;

  const participantSection = document.getElementById('participant-names-' + sectionId);
  if (!participantSection) return noop;

  const labelGroup   = config.labelGroup   || 'Partecipante';
  const labelNome    = config.labelNome    || 'Nome';
  const labelCognome = config.labelCognome || 'Cognome';
  const labelEmail   = config.labelEmail   || 'Email';
  const phNome       = config.phNome       || 'Mario';
  const phCognome    = config.phCognome    || 'Rossi';
  const phEmail      = config.phEmail      || 'mario.rossi@email.com';
  const isRequired   = config.isRequired   !== undefined ? config.isRequired : true;
  const confirmLabel = config.confirmLabel || 'Conferma partecipante';
  const editLabel    = config.editLabel    || 'Modifica';
  const errorMessage = config.errorMessage || 'Compila i dati di tutti i partecipanti prima di procedere.';

  // AbortController per rimuovere tutti i listener in un colpo solo
  const ac = new AbortController();
  const signal = ac.signal;

  let errorEl = null;
  let infoBanner = null;

  // ── HELPERS ──

  function isGroupFilled(group) {
    return Array.from(group.querySelectorAll('input')).every(i => i.value.trim() !== '');
  }

  function allGroupsComplete() {
    return Array.from(fieldsContainer.querySelectorAll('.participant-names__group'))
      .every(g => g.classList.contains('is-complete'));
  }

  function updateConfirmBtn(group) {
    const btn = group.querySelector('.participant-names__confirm');
    if (btn) btn.disabled = !isGroupFilled(group);
  }

  function confirmGroup(group) {
    if (!isGroupFilled(group)) return;
    const nome    = group.querySelector('[data-field="nome"]').value.trim();
    const cognome = group.querySelector('[data-field="cognome"]').value.trim();
    const email   = group.querySelector('[data-field="email"]').value.trim();
    group.querySelector('.participant-names__summary-name').textContent  = nome + ' ' + cognome;
    group.querySelector('.participant-names__summary-email').textContent = email;
    group.classList.add('is-complete');
    if (allGroupsComplete()) {
      errorEl.classList.remove('is-visible');
      enableCheckoutButtons();
    }
  }

  function openGroup(group) {
    group.classList.remove('is-complete');
    disableCheckoutButtons();
  }

  function showError() {
    errorEl.classList.add('is-visible');
    const firstIncomplete = Array.from(
      fieldsContainer.querySelectorAll('.participant-names__group')
    ).find(g => !g.classList.contains('is-complete'));
    if (firstIncomplete) {
      firstIncomplete.classList.remove('is-complete');
      firstIncomplete.scrollIntoView({ behavior: 'smooth', block: 'center' });
      firstIncomplete.style.transition = 'box-shadow 0.1s';
      firstIncomplete.style.boxShadow = '0 0 0 3px rgba(227,30,36,0.35)';
      setTimeout(() => { firstIncomplete.style.boxShadow = ''; }, 1500);
    }
  }

  // ── BUTTONS ──

  function disableCheckoutButtons() {
    if (infoBanner) infoBanner.classList.remove('is-hidden');
    document.querySelectorAll('#AddToCart').forEach(btn => { btn.disabled = true; });
    if (!productInfo) return;
    function applyOverlay() {
      const dw = productInfo.querySelector('.shopify-payment-button');
      if (!dw) return false;
      if (dw.querySelector('.participant-names__payment-overlay')) return true;
      dw.style.position = 'relative';
      dw.style.opacity = '0.4';
      const ov = document.createElement('div');
      ov.className = 'participant-names__payment-overlay';
      ov.style.cssText = 'position:absolute;inset:0;z-index:10;cursor:not-allowed;';
      ov.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showError();
      }, true);
      dw.appendChild(ov);
      return true;
    }
    if (applyOverlay()) return;
    const obs = new MutationObserver(() => { if (applyOverlay()) obs.disconnect(); });
    obs.observe(productInfo, { childList: true, subtree: true });
    setTimeout(() => obs.disconnect(), 5000);
  }

  function enableCheckoutButtons() {
    if (infoBanner) infoBanner.classList.add('is-hidden');
    document.querySelectorAll('#AddToCart').forEach(btn => {
      if (!btn.classList.contains('sold-out')) btn.disabled = false;
    });
    const dw = productInfo
      ? productInfo.querySelector('.shopify-payment-button')
      : document.querySelector('#ProductInfo-' + sectionId + ' .shopify-payment-button');
    if (!dw) return;
    dw.style.position = '';
    dw.style.opacity = '';
    const ov = dw.querySelector('.participant-names__payment-overlay');
    if (ov) ov.remove();
  }

  // ── RENDER ──

  function getSavedValues() {
    const saved = {};
    fieldsContainer.querySelectorAll('.participant-names__group').forEach((group, idx) => {
      saved[idx + 1] = {
        nome:     group.querySelector('[data-field="nome"]')?.value || '',
        cognome:  group.querySelector('[data-field="cognome"]')?.value || '',
        email:    group.querySelector('[data-field="email"]')?.value || '',
        complete: group.classList.contains('is-complete')
      };
    });
    return saved;
  }

  function renderFields(qty, reset) {
    const saved = reset ? {} : getSavedValues();
    fieldsContainer.innerHTML = '';
    for (let i = 1; i <= qty; i++) {
      const s = saved[i] || {};
      const wrapper = document.createElement('div');
      wrapper.className = 'participant-names__group' + (s.complete ? ' is-complete' : '');
      wrapper.innerHTML = `
        <div class="participant-names__summary">
          <div class="participant-names__summary-icon">✓</div>
          <div class="participant-names__summary-text">
            <div class="participant-names__summary-name">${(s.nome || '') + ' ' + (s.cognome || '')}</div>
            <div class="participant-names__summary-email">${s.email || ''}</div>
          </div>
          <span class="participant-names__summary-edit">${editLabel}</span>
        </div>
        <div class="participant-names__body">
          <div class="participant-names__group-heading">
            <div class="participant-names__group-number">${i}</div>
            ${labelGroup} ${i}
          </div>
          <div class="participant-names__group-fields">
            <div class="participant-names__field">
              <label for="p-nome-${sectionId}-${i}">${labelNome}</label>
              <input type="text" id="p-nome-${sectionId}-${i}" data-field="nome"
                name="properties[${labelGroup} ${i} - ${labelNome}]"
                placeholder="${phNome}" form="${formId}" value="${s.nome || ''}"
                ${isRequired ? 'required' : ''}>
            </div>
            <div class="participant-names__field">
              <label for="p-cognome-${sectionId}-${i}">${labelCognome}</label>
              <input type="text" id="p-cognome-${sectionId}-${i}" data-field="cognome"
                name="properties[${labelGroup} ${i} - ${labelCognome}]"
                placeholder="${phCognome}" form="${formId}" value="${s.cognome || ''}"
                ${isRequired ? 'required' : ''}>
            </div>
            <div class="participant-names__field participant-names__field--full">
              <label for="p-email-${sectionId}-${i}">${labelEmail}</label>
              <input type="email" id="p-email-${sectionId}-${i}" data-field="email"
                name="properties[${labelGroup} ${i} - ${labelEmail}]"
                placeholder="${phEmail}" form="${formId}" value="${s.email || ''}"
                ${isRequired ? 'required' : ''}>
            </div>
          </div>
          <button type="button" class="participant-names__confirm" ${isGroupFilled(wrapper) ? '' : 'disabled'}>
            ${confirmLabel}
          </button>
        </div>
      `;
      // I listener sui figli non hanno bisogno di AbortController — vivono col wrapper
      wrapper.querySelector('.participant-names__confirm').addEventListener('click', () => confirmGroup(wrapper));
      wrapper.querySelector('.participant-names__summary').addEventListener('click', () => openGroup(wrapper));
      wrapper.querySelectorAll('input').forEach(input => {
        input.addEventListener('input', () => updateConfirmBtn(wrapper));
      });
      fieldsContainer.appendChild(wrapper);
    }
    if (allGroupsComplete()) {
      enableCheckoutButtons();
    } else {
      disableCheckoutButtons();
    }
  }

  // ── PUBLIC ──

  function resetFields() {
    // Svuota i campi mantenendo la quantità corrente dal DOM
    const currentQty = parseInt(document.getElementById('Quantity-' + sectionId)?.value) || 1;
    renderFields(currentQty, true);
    // Ri-osserva il quantity input (potrebbe essere stato ricreato da Vision)
    observeQuantity && observeQuantity();
  }

  function start() {
    // Error element
    const existingError = participantSection.querySelector('.participant-names__error');
    if (existingError) existingError.remove();
    errorEl = document.createElement('div');
    errorEl.className = 'participant-names__error';
    errorEl.textContent = errorMessage;
    participantSection.appendChild(errorEl);

    infoBanner = document.getElementById('participant-info-banner-' + sectionId);

    // MutationObserver sul quantity input — reagisce a qualsiasi cambio di valore
    // incluso il reset post-variante, i click +/-, e la digitazione diretta
    function observeQuantity() {
      const qtyInput = document.getElementById('Quantity-' + sectionId);
      if (!qtyInput) return;

      let lastQty = parseInt(qtyInput.value) || 1;

      const qtyObserver = new MutationObserver(function() {
        const newQty = parseInt(document.getElementById('Quantity-' + sectionId)?.value) || 1;
        if (newQty !== lastQty) {
          lastQty = newQty;
          renderFields(newQty);
        }
      });
      qtyObserver.observe(qtyInput, { attributes: true, attributeFilter: ['value'] });

      // Fallback: click +/- e change per browser che non triggera mutation su value
      document.addEventListener('click', function(e) {
        const btn = e.target.closest('.plus, .minus');
        if (!btn) return;
        const qi = document.getElementById('Quantity-' + sectionId);
        if (!qi) return;
        const qs = qi.closest('quantity-selector');
        if (!qs || !qs.contains(btn)) return;
        setTimeout(() => {
          const qty = parseInt(document.getElementById('Quantity-' + sectionId)?.value) || 1;
          if (qty !== lastQty) {
            lastQty = qty;
            renderFields(qty);
          }
        }, 50);
      }, { signal });

      document.addEventListener('change', function(e) {
        if (e.target.id !== 'Quantity-' + sectionId) return;
        const qty = parseInt(e.target.value) || 1;
        if (qty !== lastQty) {
          lastQty = qty;
          renderFields(qty);
        }
      }, { signal });
    }

    observeQuantity();

    // Form submit
    const productForm = document.getElementById(formId);
    if (productForm) {
      productForm.addEventListener('submit', function(e) {
        if (!allGroupsComplete()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          showError();
        }
      }, { capture: true, signal });
    }

    // Render iniziale
    const initialQty = parseInt(document.getElementById('Quantity-' + sectionId)?.value) || 1;
    renderFields(initialQty);
  }

  function destroy() {
    ac.abort(); // rimuove tutti i listener attaccati con { signal }
    if (errorEl && errorEl.parentNode) errorEl.remove();
    errorEl = null;
  }

  return { start, destroy, resetFields };
}

// ── GLOBAL LISTENERS ──

(function() {
  let variantChangeTimeout = null;

  // Al cambio variante resetta i campi — il MutationObserver si occuperà
  // di aggiornare se Vision cambia anche il valore del quantity input
  function onVariantChange() {
    clearTimeout(variantChangeTimeout);
    variantChangeTimeout = setTimeout(function() {
      Object.keys(window.ParticipantNames._instances).forEach(function(sectionId) {
        window.ParticipantNames._instances[sectionId].resetFields();
      });
    }, 300);
  }

  document.addEventListener('variant:change', onVariantChange);
  document.addEventListener('product:variant-change', onVariantChange);

  // Quick view / Drawer
  function tryInitInDrawer() {
    const drawer = document.querySelector('#Product-Drawer');
    if (!drawer) return false;
    const containers = drawer.querySelectorAll('[id^="participant-fields-"]');
    if (!containers.length) return false;
    containers.forEach(function(container) {
      const sectionId = container.id.replace('participant-fields-', '');
      const configEl  = document.getElementById('participant-config-' + sectionId);
      if (!configEl) return;
      window.ParticipantNames.init(sectionId, JSON.parse(configEl.textContent));
    });
    return true;
  }

  document.addEventListener('quick-view:open', function() {
    if (tryInitInDrawer()) return;
    const drawer = document.querySelector('#Product-Drawer');
    if (!drawer) return;
    const obs = new MutationObserver(function() {
      if (tryInitInDrawer()) obs.disconnect();
    });
    obs.observe(drawer, { childList: true, subtree: true });
    setTimeout(function() { obs.disconnect(); }, 5000);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInitInDrawer);
  } else {
    tryInitInDrawer();
  }
})();